import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || '0',
    bgColor: searchParams.get('bgColor') || 'rgba(0,0,0,0.0)',
    title: getDefaultValue(
      searchParams.get('title'),
      'send the number of the correct answer',
    ),
    phoneNumber,
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),

    startFrom: parseInt(searchParams.get('startFrom') || '') || 3,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 100,
    authorFontSize: searchParams.get('authorFontSize') || '4.6',

    sizeQR: searchParams.get('sizeQR') || '14.7',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    carousel: searchParams.get('carousel') || '1',
  };
};
